'use client';

import { c as _c } from "react/compiler-runtime";
import type { ActivityPageFieldsFragment } from '@funkey/types/graphql/graphql';
import { usePortalCtx } from '~/features/global/portal';
import QuotationCard from './QuotationCard';
import SlideUpWithButton from './SlideUpWithButton';
import { useI18n } from '~/features/i18n';
import { Auth } from '~/modules/auth/client';
export const ActivityPageQuotationCard: React.FC<{
  activity: ActivityPageFieldsFragment;
  children?: React.ReactNode;
}> = props => {
  const $ = _c(25);
  const auth = Auth.useSession();
  const portal = usePortalCtx();
  const i18n = useI18n();
  if (portal.portal === "BIZZ" && !auth.user && portal.bizz.publicPages !== "ALLOW_BOOKING") {
    return null;
  }
  const t0 = props.activity.media?.header?.path ?? null;
  let t1;
  if ($[0] !== props.activity.activityLanguages || $[1] !== props.activity.activityVariants || $[2] !== props.activity.id || $[3] !== props.activity.name || $[4] !== props.activity.slug || $[5] !== t0) {
    t1 = <QuotationCard activity={{
      id: props.activity.id,
      name: props.activity.name,
      slug: props.activity.slug,
      imagePath: t0,
      activityVariants: props.activity.activityVariants,
      activityLanguages: props.activity.activityLanguages
    }} className="mb-5 mt-15 self-start rounded-2xl bg-white p-10 lg:mt-0" />;
    $[0] = props.activity.activityLanguages;
    $[1] = props.activity.activityVariants;
    $[2] = props.activity.id;
    $[3] = props.activity.name;
    $[4] = props.activity.slug;
    $[5] = t0;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== props.children || $[8] !== t1) {
    t2 = <aside className="sticky top-32 hidden sm:min-w-[400px] md:block lg:w-100">{t1}{props.children}</aside>;
    $[7] = props.children;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== i18n) {
    t3 = i18n._("pdp.mobile.add-to-quotation.cta");
    $[10] = i18n;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const t4 = props.activity.media?.header?.path ?? null;
  let t5;
  if ($[12] !== props.activity.activityLanguages || $[13] !== props.activity.activityVariants || $[14] !== props.activity.id || $[15] !== props.activity.name || $[16] !== props.activity.slug || $[17] !== t4) {
    t5 = <QuotationCard activity={{
      id: props.activity.id,
      name: props.activity.name,
      slug: props.activity.slug,
      imagePath: t4,
      activityVariants: props.activity.activityVariants,
      activityLanguages: props.activity.activityLanguages
    }} className="bg-white p-10 lg:mt-0" />;
    $[12] = props.activity.activityLanguages;
    $[13] = props.activity.activityVariants;
    $[14] = props.activity.id;
    $[15] = props.activity.name;
    $[16] = props.activity.slug;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t3 || $[20] !== t5) {
    t6 = <SlideUpWithButton iconBefore="plus" label={t3} className="isolate z-20 sm:hidden">{t5}</SlideUpWithButton>;
    $[19] = t3;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== t2 || $[23] !== t6) {
    t7 = <div className="relative lg:shrink-0">{t2}{t6}</div>;
    $[22] = t2;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
};